import { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { DownloadButton as StyledDownloadButton } from "./DialogStyles";
import { downloadTransactionExcel } from "./excelUtils";

interface DownloadButtonProps {
    selectedTransaction: any;
}

const DownloadButton = ({ selectedTransaction }: DownloadButtonProps) => {
    const [downloadLoading, setDownloadLoading] = useState(false);

    const handleDownloadExcel = () => {
        if (!selectedTransaction) return;

        setDownloadLoading(true);
        try {
            downloadTransactionExcel(selectedTransaction);
        } catch (error) {
            console.error('Error downloading Excel:', error);
        } finally {
            setDownloadLoading(false);
        }
    };

    return (
        <StyledDownloadButton
            onClick={handleDownloadExcel}
            disabled={downloadLoading || !selectedTransaction}
            startIcon={<DownloadIcon />}
        >
            {downloadLoading ? <CircularProgress size={20} color="inherit" /> : 'دانلود اکسل'}
        </StyledDownloadButton>
    );
};

export default DownloadButton;